export default {
  WS_CONNECTION_IS_NOT_READY:
    'You try to send WS message before connection established',
  WS_NOT_REGISTERED_EVENT:
    "You're trying to subscribe to unregistered event. Please define event",
  DEFAULT_ERROR_MESSAGE: 'Something went wrong',
  EMPTY_FIELD_MESSAGE: 'This field cannot be empty',
  INCORRECT_YEAR_FORMAT:
    'Invalid entry. Kindly retry with the correct year of birth',
  SUCCESS_IMG_ALT: 'success_screen',
  ERROR_IMG_ALT: 'error_img',
  CONTINUE: 'Continue',
  INCORRECT_OTP_FORMAT: 'You have entered incorrect otp format',
  TRANSACTION_LOGO: 'transaction_logo',
  APPROVE_TRANSACTION: 'Approve transaction',
  PROOF_OF_TRANSFER:
    'Proof of transfer as an electronic delivery delivery slip (E-DIS)',
  I_HAVE_PIN: 'I have a PIN',
  I_DONT_HAVE_PIN: 'I don’t have a PIN',
  ENTER_PIN_ON_CDSL: 'Enter a previously generated PIN on CDSL’s site.',
  CONTINUE_TO_CDSL: 'Continue to CDSL',
  FIRST_TIME_OR_FORGOT_PIN:
    'First time approving a transaction / Forgot your PIN?',
  DEMAT_ACCOUNT: 'My Upstox Demat Account',
  POOL_ACCOUNT: 'Upstox Pool Account',
  COPY_BOID: 'Copy your beneficial owner (BO) ID',
  GENERATE_NEW_PIN:
    'Continue to CDSL’s site to submit your BO ID and PAN to generate a new PIN',
  DONT_HAVE_PIN_THIRD_POINT:
    'On completion, close the windown to come back to this page and continue your journey by selecting “I have a PIN” above.',
  NEED_HELP: 'Need help?',
  WHY_AM_I_SEEING_STEP: 'Why am I seeing this step?',
  HOW_TO_APPROVE_TRANSFER: 'How do I approve a transfer?',
  APPROVE_TRANSFER_FIRST_STEP: 'Click on ‘Continue’ to go to CDSL’s site.',
  GENERATE_PIN_CDSL_LINK: 'Generate PIN on CDSL',
  APPROVE_TRANSFER_THIRD_STEP:
    'Wait to be redirected to Upstox’s status page. If everything went right, close the page and continue with confirming your order in Upstox Pro.',
  APPROVE_TRANSFER_SECOND_STEP:
    'Enter your PIN and submit it. If this is your first time using a PIN on CDSL or if you’ve forgotten your current PIN, click ‘Get a new PIN’ above on this page.',
  TRANSACTION_APPROVED: 'Transaction approved',
  TRANSACTION_CANCELED: 'Transaction cancelled',
  CLOSE_THIS_TAB: 'Close this tab',
  TRY_AGAIN: 'Try again',
  MY_LISTS: 'My lists',
  OPTION_CHAIN: 'Option chain',
  BUY: 'Buy',
  IMPORTANT_ALERTS: 'important alerts',
  VIEW_MARGIN_CALL: 'View margin call',
  GOT_IT: 'Got it',
  WALLETS: 'Wallets',
  REWARDS: 'Rewards',
  ACCOUNT: 'Account',
  LISTS: 'My lists',
  POSITIONS_TAB_TITLE: (amount: string) => `Positions ${amount}`,
  HOLDINGS_TAB_TITLE: (amount: string) => `Holdings ${amount}`,
  ORDERS_TAB_TITLE: (amount: string) => `Orders ${amount}`,
  BASKET_ORDER_QUANTITY: (quantity: string) => `${quantity} Orders`,
  POSITIONS_MTM_EXIT_ALL_BUTTON: 'Exit All',
  POSITIONS_MTM_EXIT_FAILURE: 'Failed to exit positions, Please retry',
  POSITIONS_MTM_EXIT_ALL_MODAL_TITLE: (quantity: string) => `Square off ${quantity} ${quantity === '1' ? 'position' : 'positions'} at market price`,
  SETTINGS: 'Settings',
  SELL: 'Sell',
  AS_OF_IST: (time: string) => `As of ${time} IST`,
  VIEW_UNDERLYING_SCRIP: 'View underlying scrip',
  OI: 'OI',
  OI_CHANGE: 'Change in OI',
  SPOT: 'Spot',
  OPEN: 'Open',
  CLOSE: 'Close',
  VOLUME: 'Volume',
  LOWER_CIRCUIT: 'Lower circuit',
  UPPER_CIRCUIT: 'Upper circuit',
  AVG_TRADED: 'Avg. traded',
  STATS: 'Stats',
  MARKET_DEPTH: 'Market depth',
  QUANTITY: 'Quantity',
  BID: 'Bid',
  ASK: 'Ask',
  TODAY_LOW_HIGH: 'Today’s low/high',
  YEAR_LOW_HIGH: '52 Weeks low/high',
  TOTAL_BUY_SELL: 'Total buy/sell quantity',
  TRY_SEARCHING: 'Try searching for a different scrip or company',
  EMPTY_SEARCH_TITLE: 'Search for your next profit',
  EMPTY_SEARCH_META:
    'Try searching for a scrip code, company name or market above',
  EMPTY_INBOX_FILTER_TITLE: 'No inbox alerts yet!',
  EMPTY_INBOX_FILTER_META: 'We have nothing to show in the category',
  EMPTY_PRICE_ALERTS_TITLE: 'No price alerts yet!',
  RESULTS_FOR: 'results for',
  RESULT_FOR: 'result for',
  ALL: 'All',
  CASH: 'Cash',
  CURRENCY: 'Currency',
  COMMODITY: 'Commodity',
  FUTOPT: 'F&O',
  BOID_COPIED: 'Bo ID is copied to clipboard',
  VIEW_MY_PERFORMANCE: 'View my performance',
  NEWS_FOR_YOU: 'News for you',
  VIEW_MORE_NEWS: 'View more news',
  LOG_OUT: 'Log Out',
  NET_PROFIT_LAST: (trades: string) => `Net profit over last ${trades} trades`,
  NET_PROFIT_RUNNING: (trades: string) =>
    `Net profit: Running P&L over last ${trades} trades`,
  HOLDINGS_OVER_PAST: (days: string) => `Holdings over past ${days} days`,
  TOKEN_SEARCH_NOT_FOUND: (token: string) =>
    `No search results in BOD for ${token}`,
  HOME: 'Home',
  DISCOVER: 'Discover',
  MY_PERFORMANCE: 'My performance',
  HIGHLIGHTS: 'Highlights',
  FORGOT_PIN: 'Forgot PIN',
  NOTIFICATIONS: 'Notifications',
  NOTIFICATION_SETTINGS: 'Notification settings',
  LEGAL_TERMS: 'Legal & terms of service',
  MY_STATEMENTS_LEDGERS: 'My statements and ledgers',
  MY_LINKED_ACCOUNTS: 'My linked accounts',
  MY_BANK_DETAILS: 'My bank details',
  MY_SEGMENTS: 'My segments',
  MY_TRADING_PLAN: 'My trading plan',
  FEES: 'Fees',
  WITHDRAW: 'Withdraw',
  ADD_FUNDS: 'Add funds',
  SECURITIES: 'Securities',
  COMMODITIES: 'Commodities',
  FUNDS_IN_USE: 'Funds in use',
  NET_DEPOSITS: 'Net deposits',
  TOTAL_BALANCE: 'Total balance',
  Sell: 'Sell',
  SELECT_LIST: 'Select a list',
  EDIT_MY_LISTS: 'Edit my lists',
  EDIT: 'Edit',
  SORT: 'Sort',
  SORT_BY: 'Sort by',
  FILTER: 'Filter',
  FILTER_BY: 'Filter by',
  SCRIPS: 'Scrips',
  WATCHLIST: 'Watchlist',
  WATCHLIST_LIST_BY_YOU_SUBTITLE: (number: string) =>
    `List by You • ${number} Scrips`,
  WATCHLIST_LIST_BY_UPSTOX_SUBTITLE: (number: string) =>
    `List by Upstox • ${number} Scrips`,
  WATCHLIST_SMART_LIST_BY_UPSTOX_SUBTITLE: (number: string) =>
    `Smartlist by Upstox • ${number} Scrips`,
  WATCHLIST_BUTTON_CANCEL: 'Cancel',
  WATCHLIST_BUTTON_BACK: 'Back',
  WATCHLIST_BUTTON_EDIT: 'Edit',
  WATCHLIST_BUTTON_DONE: 'Done',
  WATCHLIST_BUTTON_SAVE_CHANGES: 'Save changes',
  WATCHLIST_BUTTON_MANAGE: 'Manage lists',
  WATCHLIST_BUTTON_CREATE: 'Create list',
  WATCHLIST_CREATE_LABEL_HEADING: 'Change emoji',
  WATCHLIST_SELECTED_LABEL_HEADING: 'Selected emoji',
  WATCHLIST_CREATE_LIST_NAME: 'Give your list a name',
  WATCHLIST_BUTTON_MAYBE_LATER: 'Maybe later',
  WATCHLIST_BUTTON_CREATE_LIST: 'Create list',
  WATCHLIST_BUTTON_CREATE_LIST_CANCEL: 'Cancel',
  WATCHLIST_CREATE_NEW_LIST: 'Create new list',
  WATCHLIST_CREATE_LIST_FORM_TITLE: 'Create a list',
  WATCHLIST_NEW_LIST_LENGTH_ERROR:
    'Watchlist name cannot have more than 40 characters',
  WATCHLIST_NEW_LIST_SPECIAL_CHAR_ERROR:
    'Watchlist name cannot have special characters',
  WATCHLIST_BUTTON_DELETE_LIST: (action: string) => `${action} list`,
  WATCHLIST_CREATE_VALIDATION_HEADING: 'Can’t create list',
  WATCHLIST_CREATE_VALIDATION_SUBTEXT:
    'You’ve reached the max number of 10 lists. To create a new list you must delete one or more lists.',
  WATCHLIST_FOLLOW_VALIDATION_HEADING: 'Can’t follow list',
  WATCHLIST_FOLLOW_VALIDATION_SUBTEXT: 'Unfollow a list to follow a new one.',
  WATCHLIST_DELETE_VALIDATION_HEADING: 'Can’t delete list',
  WATCHLIST_DELETE_VALIDATION_SUBTEXT:
    'Please create a new list before you can delete this list.',
  WATCHLIST_MODAL_DELETE_TITLE: (action: string) => `${action} list?`,
  WATCHLIST_MODAL_DELETE_SUBTITLE: (action: string) =>
    `Are you sure you want to ${action} this list?`,
  WATCHLIST_EXISTS_VALIDATION_SUBTEXT: 'User watchlist already exist.',
  WATCHLIST_DUBLICATE_NAME_ERROR: 'Watchlist with the same name already exist.',
  WATCHLIST_SOMETHING_WENT_WRONG_SUBTEXT:
    'Something went wrong. Please try again after some time.',
  WATCHLIST_MAXIMUM_LENGTH_MESSAGE:
    'A maximum of 100 scrips can be added to a watchlist.',
  EMPTY_SCRIP_LIST: 'No scrips yet!',
  ADD_SCRIP: 'Add scrips',
  ADD_WATCHLIST: 'Add watchlist',
  DELETE: 'Delete',
  DELETE_LIST: 'Delete list',
  DONE: 'Done',
  LIST_NAME: 'List name',
  MANAGE_LIST: 'Manage lists',
  EDIT_A_LIST: 'Edit a list',
  SECURITIES_WALLET: 'Securities wallet',
  COMMODITIES_WALLET: 'Commodities wallet',
  AVAILABLE_TO_USE: 'Available to use',
  BALANCE: 'Balance',
  DESCRIPTION: 'Description',
  DATE: 'Date',
  AMOUNT: 'Amount',
  STATUS: 'Status',
  TRANSACTIONS: 'Transactions',
  PROCESSING: (amount: string) => `${amount} processing`,
  WITHDRAW_FUNDS: 'Withdraw funds',
  WITHDRAW_FROM_FUNDS: 'Withdraw funds from',
  WITHDRAW_HOW_MUCH: 'Amount to withdraw',
  WITHDRAW_PAYMENT_METHOD: 'Choose payment method',
  WITHDRAW_CONFIRM: 'Confirm withdrawal',
  WITHDRAW_REWARDS_CONFIRM: 'Confirm rewards withdrawal',
  WITHDRAW_FUNDS_FROM: 'Withdraw funds from',
  WITHDRAWING_FUNDS_FROM: (wallet: string) =>
    `Withdrawing funds from ${wallet} wallet`,
  WITHDRAW_FUNDS_TO: 'Withdraw funds to',
  ADD_FUNDS_HOW_MUCH: 'How much would you like to add?',
  ADD_FUNDS_TO: (wallet: string) => `Add funds to ${wallet} wallet`,
  ADD_FUNDS_UPI: (email: string) =>
    `Please check the UPI app for a payment request sent to ${email} to continue`,
  CHOOSE_PAYMENT_METHOD: 'Choose payment method',
  PAYMENT_METHOD: 'Payment method',
  WITHDRAW_LIMITED_PRIMARY_ACCOUNT:
    'Withdrawals are limited to your Primary Account',
  LEARN_MORE: 'Learn more',
  PAY_WITH: 'Payment method',
  FREE: 'Free',
  WITHDRAW_LIMITED_BANKING: 'Withdrawals are limited to Net Banking',
  CHANGE: 'Change',
  FEE: 'Fee',
  NET_BANKING: 'Net Banking',
  WITHDRAW_YOUR_FUNDS: 'Withdrawing your funds now!',
  WITHDRAWING: (withdrawAmount: string, selectedFunds: string) =>
    `Withdrawing ₹${withdrawAmount} from ${selectedFunds} wallet.`,
  VIEW_DETAILS: 'View details',
  TRANSACTION_FEE: 'Transaction fee',
  WITHDRAW_REWARDS_TOTAL: 'Total (incl. fees)',
  EST_TOTAL: 'Est. total',
  WITHDRAW_BALANCE: 'Balance',
  WITHDRAW_VALIDATE:
    'Withdraw amount must be more than 0 and less or equel your balance',
  WITHDRAW_AVALIBALE: 'Your funds will be available',
  WALLET_SORT_HIGH_LOW: 'High - Low',
  WALLET_SORT_LOW_HIGH: 'Low - High',
  WALLET_SORT_NEWEST_OLDEST: 'Newest - Oldest',
  WALLET_SORT_OLDEST_NEWEST: 'Oldest - Newest',
  GO_BACK: 'Go Back',
  SUBMIT_ORDER: 'Submit Order',
  REVIEW: 'Review',
  SUBMIT: 'Submit',
  SUBMIT_VPA: 'Submit your VPA',
  MARKET_SHARES: (side: string, amount: string) =>
    `Market ${side.toLowerCase()} ${amount} share(s)`,
  LIMIT_SHARES: (side: string, amount: string) =>
    `Limit ${side.toLowerCase()} ${amount} share(s)`,
  LIMIT_PRICE: 'Limit price',
  STOPLOSS_DELTA: 'Stoploss delta',
  TARGET_PRICE_DELTA: 'Target price delta',
  DISCLOSED_QUANTITY: 'Disclosed quantity',
  COMPLEXITY: 'Complexity',
  SIDE: 'Side',
  VALIDITY: 'Validity',
  TRIGGER_PRICE: 'Trigger price',
  ORDER_TYPE: 'Type',
  MINIMISE: 'Minimise',
  NEW_ORDER: 'New Order',
  ADVANCED_INSTUCTIONS: 'Advanced instructions',
  PRODUCT_TYPE: 'Product type',
  TRANSACTION_DETAIL: 'Transaction detail',
  DEPOSIT_AMOUNT: 'Deposit amount',
  WITHDRAW_AMOUNT: 'Withdraw amount',
  TO_SMTHING: 'To',
  FROM_SMTHING: 'From',
  TOTAL_AMOUNT: 'Total amount',
  REPORT_ISSUE: 'Report issue',
  CANCEL_TRANSACTION: 'Cancel transaction',
  SURE_TO_DELETE_TRANSACTION:
    'Are you sure you want to cancel this transaction?',
  YES: 'Yes',
  YES_CANCEL: 'Yes, cancel',
  SHOW_L3_DATA: 'Show L3 market data',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  THE_GREEKS: 'The Greeks',
  GREEKS_INFO_MESSAGE:
    'Option Greeks are used to measure the risk of an option and to gauge an option’s sensitivity to the variables that make up that risk.',
  DELTA: 'Delta',
  VEGA: 'Vega',
  GAMMA: 'Gamma',
  RHO: 'Rho',
  THETA: 'Theta',
  IMPLIED_VOLATILITY: 'Implied volatility',
  FIND_IN_ORDERS: 'Find in orders',
  FIND_IN_HOLDINGS: 'Find in holdings',
  FIND_IN_POSITIONS: 'Find in positions',
  LESS_THAN: (amount: string) => `This field must be less than ${amount}`,
  LESS_THAN_OR_EQUAL: (amount: string) =>
    `This field must be less than or equal to ${amount}`,
  LESS_THAN_PRICE: (amount: string) =>
    `This field must be less than price ${amount}`,
  GREATER_THAN_PRICE: (amount: string) =>
    `This field must be greater than price ${amount}`,
  LESS_THAN_OR_EQUAL_QUANTITY: (amount: string) =>
    `This field must be less than or equal to the quantity ${amount}`,
  MORE_THAN: (amount: string) => `This field must be more than ${amount}`,
  MORE_THAN_OR_EQUAL: (amount: string) =>
    `This field must be more than or equal to ${amount}`,
  MORE_THAN_PRICE: (amount: string) =>
    `This field must be more than price ${amount}`,
  DISCLOSED_QUANTITY_META:
    'Disclosed quantity allows you to disclose only a part of the actual quantity you want to buy/sell.',
  DAY_VALIDITY_META:
    'Day means your order has validity until the end of the trading day. If the order is not filled at market close, the order will be cancelled automatically.',
  IOC_VALIDITY_META:
    'An Immediate Or Cancel (IOC) order dictates that any portion of the  order that does not fill immediately will be cancelled.',
  TARGET_PRICE_META:
    'The difference between the Limit Price and the price you want the Target Price to initiate. ',
  STOP_LOSS_META:
    'The difference between the limit price and the price you want the Stoploss to initiate.',
  // relative date formats
  NOW: 'Now',
  ONE_MIN_FUTURE: 'In 1 minute',
  ONE_MIN_PAST: '1m',
  ONE_MIN_PAST_WITH_SUFFIX: '1m ago',
  FEW_MIN_FUTURE: (number: string) => `In ${number} minutes`,
  FEW_MIN_PAST: (number: string) => `${number}m`,
  FEW_MIN_PAST_WITH_SUFFIX: (number: string) => `${number}m ago`,
  ONE_HOUR_FUTURE: 'In 1 hour',
  ONE_HOUR_PAST: '1h',
  ONE_HOUR_PAST_WITH_SUFFIX: '1h ago',
  FEW_HOURS_FUTURE: (number: string) => `In ${number} hours`,
  FEW_HOURS_PAST: (number: string) => `${number}h`,
  FEW_HOURS_PAST_WITH_SUFFIX: (number: string) => `${number}h ago`,
  ONE_DAY_FUTURE: 'Tomorrow',
  ONE_DAY_PAST: '1d',
  ONE_DAY_PAST_WITH_SUFFIX: '1d ago',
  FEW_DAYS_FUTURE: (number: string) => `In ${number} days`,
  FEW_DAYS_PAST: (number: string) => `${number}d`,
  FEW_DAYS_PAST_WITH_SUFFIX: (number: string) => `${number}d ago`,
  ONE_WEEK_FUTURE: 'In 1 week',
  ONE_WEEK_PAST: '1w',
  ONE_WEEK_PAST_WITH_SUFFIX: '1w ago',
  // end of relative date formats
  SUBMITTED: 'Submitted',
  PRICE: 'Price',
  SUBMITTED_QTY: 'Submitted qty',
  DISCLOSED_QTY: 'Disclosed qty',
  VIEW_BREAKDOWN: 'View breakdown',
  ORDER_DETAILS: 'Order details',
  TRADED_QTY: 'Traded qty.',
  PARTIAL_FILL: 'Partial fill.',
  WITHDRAW_REWARDS: 'Withdraw rewards',
  WITHDRAW_REWARDS_FROM: 'Withdraw rewards from',
  MIN_MAX_FUNDS_AMOUNT: (maxAmount: string) =>
    `Transactions must be a value between ₹100—₹${maxAmount}`,
  WITHDRAWALS_EXCEED_BALANCE:
    'Withdrawals must not exceed your wallet balance.',
  TAKE_FUNDS_FROM: 'Take funds from',
  CONTINUE_WITH: 'Continue with',
  TIME_UNTIL_EXPIRE: 'Time until request expires',
  COMPLETE_NET_BANKING_REQUEST:
    'Complete the Net Banking request in your browser with your preferred bank to proceed.',
  CANCEL_DEPOSIT: 'Cancel deposit',
  TIME_EXPIRED: 'Time expired',
  TIME_EXPIRED_UPI_MODAL:
    'Transaction could not complete. To complete your deposit you must confirm in the UPI app on your phone within 10 minutes. No funds will be deducted from your bank account.',
  TIME_EXPIRED_NET_BANKING_MODAL:
    'Transaction could not complete. To complete your deposit you must complete your bank flow within 10 minutes. No funds will be deducted from your bank account.',
  HAVING_TROUBLE: 'Having trouble?',
  VISIT_SUPPORT: 'Visit Support',
  SUCCESS_FUNDS_ADDITION_TITLE: 'Got it! Adding your funds now',
  ADDING_TO: (amount: string) => `Adding ₹${amount} to`,
  EST_TOTAL_COST: 'Est. total cost',
  INITIAL_TOTAL_COST: 'Initial estimated cost',
  MODIFY_EST_TOTAL_COST: (amount: string) =>
    `Est. cost before modification ₹${amount}`,
  TRANSACTION_ERROR_MODAL_TITLE: 'Transaction error',
  TRANSACTION_ERROR_MODAL_DESCRIPTION:
    'Any funds deducted from your bank account will be reversed in 24 hours.',
  VPA_MODAL_DESCRIPTION:
    'Once submitted, you will need to check your phone’s UPI app to continue this process.',
  VPA_INPUT_LABEL: 'Enter Virtual Payment Address',
  INVALID_VPA: 'Incorrect VPA, please try again',
  NO_FEE: 'No fee',
  UNAVAILABLE_METHODS: 'Unavailable methods',
  CHOOSE_BANK: 'Choose a bank',
  SENT_6_DIGIT_OTP: 'We sent a 6-digit OTP to',
  VERIFY_YOUR_NUMBER: 'Verify your number',
  SEND_OTP_AGAIN: 'Send OTP again',
  SENDING_OTP: 'Sending OTP...',
  WHERE_ADD_FUNDS_TO: 'Where would you like to add funds?',
  TRADE_ID: 'Trade ID',
  COST: 'Cost',
  EXEC_ID: 'Exec ID',
  OCO_BANNER_META:
    'Limit price is required for all OCO orders. Please turn on ‘Limit price’ above to continue with this order type.',
  BSE_OCO_BANNER_META:
    'OCO orders are not available for assets traded on the BSE.',
  EXIT_OCO_BANNER_META: 'Limit price is required for all OCO orders.',
  TRADES_ORDER: 'Order',
  TRADES_ORDERS: 'Orders',
  VIEW_SCRIP: 'View scrip',
  MODIFY: 'Modify',
  MODIFY_ORDER_SUMMARY: 'Modify order summary',
  MODIFY_ORDER: 'Modify order',
  CANCEL_ORDER: 'Cancel order',
  CANCEL_ORDER_TITLE: 'Cancel order?',
  CANCEL_ORDER_CONFIRM_BUTTON: 'Yes, cancel',
  QTY: 'Qty',
  TAXES_AND_CHARGES: 'Taxes and charges',
  BROKERAGE_FEE: 'Brokerage fee',
  STT_CTT: 'STT/CTT',
  TRANSACTION_CHARGES: 'Transaction charges',
  CLEARING_CHARGES: 'Clearing charges',
  GST: 'GST',
  STATE_STAMP_TUTY: 'State stamp tuty',
  COST_OF_TRADE: 'Cost of trade',
  TAXES_WARNING:
    'On using Margin Trading Facility, interest of Rs. 20 per day will be charged for every Rs. 50,000 borrowed',
  TOTAL_TAXES: 'Total taxes and charges',
  MARGIN_COVERAGE: 'Margin coverage',
  UPFRONT_MARGIN: 'Upfront margin',
  EXPOSURE_MARGIN: 'Exposure margin',
  VALUE_AT_RISK_MARGIN: 'Value at risk margin',
  NET_PREMIUM: 'Net premium',
  TOTAL_MARGIN: 'Total margin coverage',
  DEPOSIT_FROM: 'Deposit from',
  WITHDRAW_FUNDS_VIA: (payWith: string) => `Withdraw funds via ${payWith}`,
  REWARDS_SEND_REMINDER: 'Send reminder',
  REWARDS_INVITE_FRIENDS: 'The more friends you invite, the more you earn!',
  REWARDS_GET_STARTED: 'Learn advanced trading concepts',
  REWARDS_LEARN_TO_MAKE: 'Make the most out of news & market updates',
  REWARDS_INTIVE_PROMOTION: 'Refer a friend and get rewards',
  REWARDS_BALANCE: 'Rewards balance',
  REWARDS_INVITED_TO_UPSTOX: 'Invited to Upstox',
  REWARDS_PENDING_REWARDS: 'Pending rewards',
  REWARDS_PENDING_INVITE: 'Pending invite',
  INVESTED: (amount: string) => `Invested ₹${amount}`,
  REWARDS_REMINDER_ALL:
    'Send a reminder to everyone you’ve invited to Upstox that hasn’t signed up yet.',
  HOLDINGS: 'Holdings',
  POSITIONS: 'Positions',
  TRADE: 'Trade',
  OVERALL_PNL: 'Overall P&L',
  MODIFY_ORDER_BANNER:
    'Certain fields are not able to be modified based on the order type.',
  HOLDING_DETAIL: 'Holding detail',
  AVG_PRICE: 'Avg. price',
  CURRENT_VALUE: 'Current value',
  DAY_PNL: 'Day P&L',
  PERCENTAGE_PNL: '% P&L',
  PRODUCT: 'Product',
  AGO: 'ago',
  REWARDS_INVITE_NAME: 'Enter friend’s name',
  REWARDS_INVITE_PHONE_NUMBER: 'Enter friend’s mobile number',
  REWARDS_ABOUT_LINK: 'Check this out. I’ve been using Upstox to trade.',
  REWARDS_COPY_LINK: 'Copy link',
  REWARDS_SEND_INVITE: 'Send invite',
  REWARDS_INVITE_TITLE: 'Invite a friend',
  REWARDS_ANOTHER_INVITE: 'Send another invite',
  REWARDS_INVITE_SENT: 'Invite sent!',
  REWARDS_SENT_MORE_INVITES:
    'Send more invites for the chance to earn more rewards.',
  REWARDS_LINK_COPIED: 'Link copied!',
  REWARDS_WALLET: 'Rewards wallet',
  REWARDS_INVITATION_FRIENDS: 'Invite friends',
  PENDING_INVITES: 'Pending invites',
  ORDER_EXIT_QUANTITY: 'Exit quantity',
  ORDER_ESTIMATED_COST: 'Initial estimated cost',
  ESTIMATED_CHARGES: 'Estimated Charges',
  ORDER_MARGIN_COVERAGE: 'Margin coverage',
  ORDER_TAXES_AND_CHARGES: 'Taxes and charges',
  ORDER_COST_BREAKDOWN: 'Estimated cost breakdown',
  ORDER_UPRONT_MARGIN: 'Upfront margin',
  ORDER_EXPOSURE_MARGIN: 'Exposure margin',
  ORDER_VAR_MARGIN: 'Value at risk margin',
  ORDER_NET_PREMIUM: 'Net premium',
  ORDER_TOTAL_MARGIN: 'Total margin coverage',
  ORDER_PLACE_AGAIN: 'Place order again',
  EXIT: 'Exit',
  CONVERT: 'Convert',
  CONVERT_POSITIONS: 'Convert positions',
  CONVERT_HOLDINGS: 'Convert holdings',
  SHOW_LEGEND: 'Show legend',
  HIDE_LEGEND: 'Hide legend',
  TABLE_VIEW: 'Table view',
  CREATE_STRATEGY: 'Create strategy',
  ADD_TO_STRATEGY: 'Add to strategy',
  STRATEGY_MODE: 'Strategy mode',
  REVIEW_STRATEGY: 'Review strategy',
  STRATEGY_ORDER: 'Strategy order',
  GET_STARTED: 'Get started',
  GET_STARTED_ARTICLE_1:
    'Hover on any row in option chain & select a buy/sell side for a put/call option.',
  GET_STARTED_ARTICLE_2:
    'In the next screen you will be able to Change Quantity, set limit price & add the order to strategy.',
  VIEW_MORE: 'View more',
  ORDER_TAXES_AND_CHANRGES: 'Taxes and charges',
  ORDER_BROKERAGE_FEE: 'Brokerage fee',
  ORDER_STT_CTT: 'STT/CTT',
  ORDER_TRANSACTION_CHARGES: 'Transaction charges',
  ORDER_CLEARING_CHARGES: 'Clearing charges',
  ORDER_GST: 'GST',
  ORDER_STAMP_DUTY: 'State stamp duty',
  ORDER_COST_OF_TRADE: 'Cost of trade',
  ORDER_TAXES_MESSAGE:
    'On using Margin Trading Facility, interest of Rs. 20 per day will be charged for every Rs. 50,000 borrowed',
  ORDER_TOTAL_TAXES_AND_CHANRGES: 'Total taxes and charges',
  OI_AND_CHANGES: 'OI & changes',
  IV: 'IV',
  BID_PRICE_AND_QTY: 'Bid price & qty',
  ASK_PRICE_AND_QTY: 'Ask price & qty',
  LTP_AND_CHANGE: 'LTP & change',
  LTP: 'LTP',
  SELECT_TABLE_COLUMNS: 'Select table columns',
  SELECT_EXPIRY_DATE: 'Select an expiry date',
  ALL_INSTRUMENTS: 'All instruments',
  EQUITIES: 'Equities',
  HOLDINGS_ALL_INSTRUMENTS: 'All instruments',
  HOLDINGS_TRADEED_TODAY: 'Traded today',
  HOLDINGS_PROFIT_HL: 'Profit: High – Low',
  HOLDINGS_PROFIT_LH: 'Profit: Low – High',
  PERCENT_HL: '% High – Low',
  PERCENT_LH: '% Low – High',
  PRICE_HL: '₹ High – Low',
  PRICE_LH: '₹ Low – High',
  ALPHABET_AZ: 'A-Z',
  ALPHABET_ZA: 'Z-A',
  TRADES_POSITIONS: 'Positions',
  ORDER_SENT: 'Order sent!',
  EXIT_ORDER_SENT: 'Exit order sent!',
  MODIFIED_ORDER_SENT: 'Modified order sent!',
  ORDER_ENTRY_SUCCESS_LEFT: 'Your order to',
  VIEW_ORDER: 'View order',
  SOLD: 'Sold',
  TODAY: 'Today',
  BOUGHT: 'Bought',
  PREVIOUS_DAYS: 'Previous Days',
  CANCELING_ORDER: 'Cancelling order...',
  CANCEL_ORDER_LOADING_META: 'Please wait while we cancel your order.',
  FAILED_TO_CANCEL: 'Failed to cancel',
  TRY_TO_CANCEL: 'Please try again or go back.',
  POSITION_SUMMARY: 'Position summary',
  NET_POSITION: 'Net position',
  NET_HOLDING: 'Net holding',
  NET_POSITION_INFO:
    'Net position is the sum of your intraday positions from today and any positions carried over from previous days.',
  NET_HOLDING_INFO:
    'Net holding is the sum of your delivery positions from today and any positions carried over from previous days.',
  NET_TRADE_TOTAL: 'Net trade total',
  NET_SIDE: 'Net side',
  NET_QTY: 'Net quantity',
  ABOUT: 'About',
  SMART_FILTERS: 'Smart filters',
  VIEW_CHART: 'View chart',
  OPTION_DETAIL: 'Option detail',
  UNFOLLOW: 'Unfollow',
  NEW_ANNOUNCEMENTS: 'New announcements',
  INBOX: 'Inbox',
  VIEW_ALL: 'View all',
  VIEW_FULL_INBOX: 'View full inbox',
  SELECT_EXCHANGE_FOR_TRADE: 'Select an exchange to trade on',
  SELECT_EXCHANGE_FOR_EXIT: 'Select an exchange to exit',
  SELECT_EXCHANGE_FOR_CONVERT: 'Select exchange to convert',
  DISCOVER_SUBTITLE: 'New ways to explore scrips and lists',
  CANCEL_ORDER_META: 'Are you sure you want to cancel this order?',
  ORDER_REVIEW_TITLE: (product: string) => `${product} order summary`,
  NEW: 'New',
  OLDER_NOTIFICATIONS: 'Older notifications',
  DISCOVER_FEATURED_SECTION_TITLE: 'Featured lists',
  DISCOVER_SMARTLIST: 'Smartlist',
  DISCOVER_LIST: 'List',
  DISCOVER_BUTTON_VIEW_ALL: 'View all',
  NET: 'Net',
  BOUGHT_TODAY: 'Bought (Today)',
  BOUGHT_BEFORE: 'Bought (Before)',
  SOLD_TODAY: 'Sold (Today)',
  SOLD_BEFORE: 'Sold (Before)',
  BOUGHT_DEMAT: 'Bought (Demat)',
  BOUGHT_T1: 'Bought (T1)',
  WITHDRAWAL: 'Withdrawal',
  DEPOSIT: 'Deposit',
  ORDER_CANCELLED: 'Order cancelled',
  ORDER_REJECTED: 'Order rejected',
  CONTINUOUS_CHARTS_INFO: 'Continuous charts data is available only for daily, weekly and monthly candles.',
  ORDER_MODIFIED: 'Order modified',
  ORDER_FAILED: 'Order failed',
  ORDER_TRADED: 'Order traded',
  PRICE_ABOVE: 'Price above',
  PRICE_BELOW: 'Price below',
  PRICE_DOWN: 'Price down',
  ADD_NOTE: 'Add a note',
  REWARD_INVITATION: 'Reward invitation',
  REWARD_REMINDER: 'Reward reminder',
  REWARD_WITHDRAWAL: 'Reward withdrawal',
  CUSTOM: 'Custom',
  ORDERS: 'Orders',
  FUNDS: 'Funds',
  PRICE_ALERTS: 'Price alerts',
  PRICE_ALERT: 'Price alert',
  MARGIN: 'Margin',
  DISCOVER_TOP_PERFORMING_SECTION_TITLE: 'Top performing lists',
  OPEN_ORDERS: 'Open Orders',
  TRADE_HISTORY: 'Trade History',
  DISCOVER_TABLE_NAME: 'Name',
  DISCOVER_TABLE_CHART: 'Day chart',
  DISCOVER_TABLE_LAST_PRICE: 'Last price',
  DISCOVER_TABLE_CHANGE: 'Change',
  DISCOVER_TABLE_VOLUME: 'Volume',
  MULTIPLE_OF: (value: string) => `This field must be a multiple of ${value}`,
  APPROX: 'Approx',
  DISCOVER_LOAD_MORE_SCRIPS: 'Load more scrips',
  DISCOVER_FOLLOW: 'Follow',
  DISCOVER_FOLLOWING: 'Following',
  DISCOVER_UNFOLLOW: 'Unfollow',
  WATCHLIST_REORDER_SUCCESS: 'Changes saved!',
  BUTTON_SAVE: 'Save',
  BUTTON_CONFIRM: 'Confirm',
  WATCHLIST_REORDER_ERROR: 'Couldn’t save changes. Please try again.',
  RELATED_NEWS: 'Related news',
  WATCHLIST_CREATED: 'Created',
  WATCHLIST_UPDATED: 'Last updated',
  WATCHLIST_CREATED_BY: 'Created by',
  VIEW_ALL_SCRIPS: 'View all scrips',
  NO_NEWS: 'No news',
  WATCHLIST_WAS_CREATED: 'List was created.',
  EXIT_POSITION: 'Exit position',
  EXIT_HOLDING: 'Exit holding',
  EXIT_SIDE: 'Exit side',
  POSITIONS_MTM_MODAL_DISCLAIMER: 'This will exit all your open positions by placing opposite orders (e.g., Sell → Buy) at market price, excluding Equity Delivery and MTF orders.',
  SUBMIT_EXIT_ORDER: 'Submit exit order',
  EXIT_ORDER_REVIEW_TITLE: 'Exit order summary',
  INITIAL_EST_COST: 'Initial estimated cost',
  NO_RESULTS: 'No results',
  CONVERT_HOLDING_DELIVERY_TO_INTRADAY: (selected: string, total: string) =>
    `Convert ${selected} of ${total} shares from Delivery to Intraday`,
  CONVERT_POSITION_DETAILS: (
    selected: string,
    total: string,
    oldProduct: string,
    newProduct: string,
  ) =>
    `Convert ${selected} of ${total} shares from ${oldProduct} to ${newProduct}`,
  COMPLETE_CONVERSION: 'Your conversion is complete!',
  CONVERTED_DELIVERY_TO_INTRADAY:
    'This holding has been converted from Delivery to Intraday.',
  COMPLETE_CONVERSION_META: (oldProduct: string, newProduct: string) =>
    `This position has been converted from ${oldProduct} to ${newProduct}.`,
  PROCESSING_REQUEST: 'Processing your request',
  CONVERSION_PARTIALLY: 'Your conversion is partially fulfilled.',
  CONVERSION_FAILED_TITLE: 'Your conversion failed.',
  CONVERSION_HOLDING_FAILED_MESSAGE:
    'We couldn’t convert this holding due to conversion failure reason.',
  CONVERSION_POSITION_FAILED_MESSAGE:
    'We couldn’t convert this position due to conversion failure reason.',
  PARTIALLY_CONVERTED_INFO:
    'This position is partially converted. We’re awaiting confirmation for the pending shares.',
  PARTIALLY_CONVERTED_HOLDING_INFO:
    'This holding is partially converted. We’re awaiting confirmation for the pending shares.',
  FAILED_CONVERSION_INFO:
    'We couldn’t fully convert this position due to conversion failure reason.',
  QTY_CONVERTED: 'Qty. converted',
  QTY_PENDING: 'Qty. pending',
  QTY_FAILED: 'Qty. failed',
  BACK_TO_POSITIONS: 'Back to Positions',
  RETRY_FAILED: 'Retry failed',
  RETRY_LOADING: 'Retry Loading',
  REWARDS_WALLET_AVAILABLE: 'Available to withdraw',
  REWARDS_WALLET_EARNED: 'Total earned',
  REWARDS_WALLET_WITHDRAWN: 'Total withdrawn',
  EMPTY_POSITIONS_TITLE: 'No positions yet',
  EMPTY_POSITIONS_DESCRIPTION: 'You’ll find your Intraday positions here',
  EMPTY_HOLDINGS_TITLE: 'No holdings yet',
  EMPTY_HOLDINGS_DESCRIPTION: 'You’ll find your Delivery positions here',
  EMPTY_ORDERS_TITLE: 'No orders yet',
  EMPTY_ORDERS_DESCRIPTION: 'You’ll find all your Orders here',
  EXCEED_MAX_QUANTITY: 'Conversion quantity has exceed max quantity',
  ENTER_QUANTITY: 'Enter quantity',
  SUBMIT_REQUEST: 'Submit request',
  CLEAR_BUTTON: 'Clear',
  ITEMS_TO_UPDATE_WATCHLIST: (name: string, length: string) =>
    `‘${name}’ + ${length} other`,
  UPDATE_WATCHLIST: (scrips: string, watchlists: string) =>
    `${scrips} added to ${watchlists}`,
  CANCEL_BUTTON: 'Cancel',
  PLACE_ORDER: 'Place order',
  SAVE_ORDER: 'Save order',
  EMPTY_ORDER_LIST: 'Orders list is empty',
  SCRIP_IS_NOT_FOUND: 'This scrip is not found',
  PLEASE_EDIT_ORDERS: 'Please edit all orders marked as invalid',
  LIVE_DATA_SOCKET_FAIL: 'Price data is out of sync',
  PORTFOLIO_SOCKET_FAIL:
    'Your orders, positions and holdings data is out of sync',
  BOTH_SOCKET_FAIL: 'No internet connection',
  TECH_ISSUES_DESCRIPTION: 'Please check your connection and try again.',
  RELOAD_APP: 'Try again',
  BETA_TESTING_DENIED:
    'You do not have the access to beta testing of PRO 4.0. Please contact to administrator',
  POSITION_PNL: (product: string) => `${product} position P&L`,
  INVALID_PHONE: 'You have entered an invalid mobile number. Please try again.',
  ENTER_OTP_LABEL: 'Enter your OTP',
  PRICE_ALERT_CREATED: 'Price alert has been created.',
  PRICE_ALERT_MODIFIED: 'Price alert has been modified.',
  PRICE_ALERT_DELETED: 'Price alert has been deleted.',
  NOT_ZERO_VALUE: "Value can't be 0",
  NON_NEGATIVE_VALUE: "Value can't be less than 0",
  INVALID_NUMBER: 'Invalid price value',
  ILLIQUID: 'Illiquid',
  PRICE_ALERT_NOTE_HELP_CONTENT: (value: string) =>
    `${value} character${+value < 2 ? '' : 's'} remaining`,
  EMPTY_HISTORY_TITLE: 'No history yet!',
  EMPTY_HISTORY_META: 'We have nothing to show in the category',
  AWAITING_STATUS: 'Awaiting status',
  BACK_TO_CDSL:
    'Go back to the CDSL’s site tab to approve this transaction with a PIN.',
  EDIS_FAILED:
    'Edis Authorisation Failed',
  BACK_TO_ORDER: 'Back to order',
  SCRIP_TEMPORARY_UNAVAILABLE: 'This scrip is temporary untradable.',
  SCRIP_STATS_UNAVAILABLE:
    "You're early! Stats currently unavailable for this scrip - check later.",
  T1_DEMAT_BREAKDOWN: 'about T1 holdings, Demat holdings, and their breakdown.',
  INDEX: 'Index',
  NEED_TO_ACTIVATE_SEGMENT: 'You need to activate F&O segment',
  SEGMENT_ACTIVATE_META:
    'This segment is not currently activated on your account. Tap on the button to get started!',
  ACTIVATE_SEGMENT: 'Activate Segment',
  TRANSACTION_PROCESSING: '1 Transaction processing',
  REWARDS_INVITE_VALIDATION_MESSAGE:
    'Name should contain alphabets in English and has to be 2-30 characters long',
  COMPLETE_PROCESS: 'Complete process',
  OPEN_UPSTOX_ACCOUNT: 'Open Upstox account',
  CHECK_STATUS: 'Check Status',
  SIGN_UP: 'Sign up',
  HALF_DONE: 'Well begun is half done!',
  OPEN_IN_PROGRESS:
    'Your account opening process is still pending, complete it soon and start your investing journey with Upstox.',
  GOOD_THING_TAKE_TIME: 'All good things take time!',
  RECEIVED_DOCUMENTS:
    'We have received your documents & are reviewing it currently. It’ll take 24-48 hrs.',
  ABOUT_THERE: 'You are just about there.',
  DEMAT_ACCOUNT_APPROVED:
    'Your Demat application has been approved. Your account will be activated very soon!',
  SOMETHING_NOT_RIGHT: "Something wasn't right.",
  WE_ARE_SORRY:
    "We're sorry! Your application got rejected. Tap on 'Learn more' to know why.",
  EXPLORE_APP: 'Explore app',
  EXPLORE_THE_APP: 'Explore the app',
  VIEW_POSITIONS: 'View positions',
  MARGIN_ALERT_MODAL_TITLE: 'You have been issued a margin call',
  MARGIN_ALERT_MODAL_DESCRIPTION: (wallet: string) =>
    ` into your ${wallet} Wallet or sell scrips to raise your portfolio value above your margin maintinence.`,
  PROFILE: 'Profile',
  PROFILE_SUBTITLE: 'Contact, Trading segments, Bank details, Nominee details.',
  REPORTS: 'Reports',
  REPORTS_SUBTITLE: 'Ledger, Profit & Loss, Holdings, Trade reports.',
  CORPORATE_ACTIONS: 'Corporate Actions',
  CORPORATE_ACTIONS_SUBTITLE: 'Buybacks, Takeovers, Delistings & OFS.',
  IPO: 'IPO',
  MUTUAL_FUNDS: 'Mutual funds',
  IPO_INVEST_CARD_SUBTITLE:
    'Invest in announced IPOs and track your applications',
  MF_INVEST_CARD_SUBTITLE: 'Choose from 10,000+ top curated funds',
  REWARDS_MESSAGE_PREVIEW: 'Message preview',
  REWARDS_INVITE_MESSAGE: (userName: string) =>
    `Hello there! ${userName} has referred you to Upstox, India's fastest-growing broker. Along with a no-free demat account, there are plenty of other benefits awaiting you.`,
  REWARDS_WITHDRAWAL: 'Rewards withdrawal',
  REWARDS_INVITE: (name: string) => `Invite credit - ${name}`,
  PRICE_ALERT_INPUT_PLACEHOLDER: 'Enter a price',
  ENABLE_COMMODITIES_WALLET_MESSAGE_START: 'Invest or trade in Metals, Energy,',
  ENABLE_COMMODITIES_WALLET_MESSAGE_END: 'and Agricultural commodities',
  ENABLE_COMMODITIES_WALLET: 'Enable Commodities wallet',
  ENABLE_SECURITIES_WALLET_MESSAGE_START: 'Invest or trade in Equity,',
  ENABLE_SECURITIES_WALLET_MESSAGE_END: 'Futures & Options, and Derivatives',
  ENABLE_SECURITIES_WALLET: 'Enable Securities wallet',
  WELCOME_TO_UPSTOX: 'Welcome to the new Upstox!',
  WELCOME_TO_UPSTOX_SUBTITLE:
    'While we work on getting even better, you can still access the older version of Upstox at pro.upstox.com',
  BACK_TO_OLD_APP: 'Back to old Upstox',
  ACCESS_OLD_VERSION: 'Access old version',
  MARKET: 'Market',
  DARK_THEME: 'Dark Theme',
  UNABLE_TO_WITHDRAW_REWARDS_TITLE: 'Unable to withdraw rewards',
  UNABLE_TO_WITHDRAW_REWARDS_TEXT:
    'To be able to withdraw your rewards, you must be an active Upstox user. Your account is currently inactive because you haven’t traded in the last one year. To activate your account, please place a trade.',
  LOAD_MORE: 'Load more',
  COMPANY_PROFILE: 'Company profile',
  FUTURES_AND_OPTIONS_GET_STARTED:
    'Getting started in Futures & Options today with our guide',
  REVIEW_STRATEGY_HEADING: 'Review strategy',
  SUMMARY_STRATEGY_HEADING: 'Order summary',
  MARKET_ORDER: 'Market order',
  LIMIT_ORDER: 'Limit order',
  ASK_PRICE: 'Ask price',
  FUNDS_NEEDED: 'Funds needed',
  FUNDS_AVAILABLE: 'Funds available',
  DELIVERY: 'Delivery',
  TOTAL_ORDERS: 'Total orders',
  STRATEGY_ALERT_TEXT: (amount: string) => `You can add ${amount} more orders`,
  CHECK_ORDER_STATUS: 'Check order status',
  STRATEGY_ORDER_SUCCESS_INFO:
    "Once the order is successful, it'll be visible in your",
  ORDER_RECEIVED: 'Order received',
  FAILED_TO_SUBMIT: 'Try again',
  STRATEGY_SUCCESS_INFO: (amount: string) =>
    `We’ve received your order${+amount > 1 ? 's' : ''} for`,
  OPTION: 'Option',
  OPTIONS: (amount: string) => `option${+amount > 1 ? 's' : ''}`,
  STRATEGY_FAILED_INFO:
    "Due to some network issues, we couldn't place this order. Try placing your order again.",
  REWARDS_REMINDER_SENT: 'Reminder sent!',
  REWARDS_REMINDER_SENT_DESCRIPTION:
    'A reminder has been sent to all your pending invites.',
  BID_PRICE: 'Bid price',
  EXIT_STRATEGY_MODAL_HEADING: 'Exit the strategy?',
  EXIT_STRATEGY_MODAL_CLOSE: 'Yes, exit the strategy',
  EXIT_STRATEGY_MODAL_CONTINUE: 'No, I want to continue',
  EXIT_STRATEGY_MODAL_INFO:
    'The orders you’ve added to strategy won’t be saved and you’ll have to start over again. Do you still want to exit?',
  CALL: 'call',
  PUT: 'put',
  REWARDS_YET_TO_BE_CREDITED: 'Rewards yet to be credited',
  REWARDS_CREDITED_BANNER_TEXT: `This amount is available to withdraw once it's credited to your Upstox
  account. The referral amount is credited on the 1st or 16th of each
  month. If it's a weekend or a bank holiday on those dates, the amount is
  credited on the next working day.`,
  REWARDS_BANNER_TEXT:
    'Once your referral successfully opens an Upstox account, you can withdraw the referral rewards by the 1st or the 16th of that month whichever is closer. If the 1st or 16th is a weekend or a bank holiday, you can withdraw the rewards by the next working day.',
  SEBI_CHARGES: 'SEBI charges',
  ACTIVE_MTF: 'Activate margin trading facility',
  GET_STARTED_MTF: 'Get started with margin trading today!',
  MARGIN_TRADING_FACILITY: 'Margin Trading Facility',
  TERMS_AND_CONDITIONS: 'Terms & conditions',
  WHAT_IS_MTF: "What's a Margin Trading Facility?",
  WHAT_IS_MTF_DESCRIPTION_1_LINK: 'here',
  WHAT_IS_MTF_DESCRIPTION_1:
    'It’s a service that helps you purchase more shares than you could with just the available cash in your account. You can borrow up to 50% of funds from Upstox to purchase any NSE stocks listed ',
  WHAT_IS_MTF_DESCRIPTION_2:
    'Example: You wish to buy XYZ shares worth ₹1,00,000 but you just have ₹50,000 in hand. Using Margin Trading Facility (MTF) you can still buy shares worth ₹1,00,000, as Upstox would lend you the rest ₹50,000.',
  WHAT_IS_MTF_DESCRIPTION_3:
    'MTF simply increases your buying power, allowing you to free up funds or trade more of your chosen stock.',
  WHAT_ARE_THE_CHARGES: 'What are the charges?',
  WHAT_ARE_THE_CHARGES_DESCRIPTION_1:
    'We charge ₹20 per day on each ₹50,000 that you borrow. This means that if you borrow ₹1,50,000 then you’ll be charged ₹60 per day. (₹20 for every ₹ 50,000).',
  WHAT_ARE_THE_CHARGES_DESCRIPTION_2:
    'And if you borrow ₹80,000, you would pay ₹20 per day (for the first ₹50,000)+ ₹20 per day (for the other ₹30,000). This makes the total charges to be ₹40 per day.',
  WHY_SHOULD_OPT: 'But, why should I opt for MTF?',
  WHY_SHOULD_OPT_DESCRIPTION_1:
    'To increase your buying power. With MTF (Margin Trading Facility), you no longer restrict yourself from investing in great opportunities because of a shortage of funds.',
  HOW_ACTIVE_IT: 'And how do I activate it?',
  HOW_ACTIVE_IT_DESCRIPTION_1:
    'Activating MTF on Upstox is completely free. It’s an easy, paperless, one-time process. Just follow a few steps and get funds approved in no time.',
  HOW_ACTIVE_IT_DESCRIPTION_2:
    'Once activated, you’re in full control of how and where you want to use this service. You’ll see an option to toggle MTF On/Off on every transaction.',
  HOW_I_WILL_GET_FUNDS: 'How will I get the funds?',
  HOW_I_WILL_GET_FUNDS_DESCRIPTION_1_LINK:
    'For more details, check this article.',
  HOW_I_WILL_GET_FUNDS_DESCRIPTION_1:
    'Once your MTF account is activated, the approved amount (we fund up to 50%) becomes active for you. Just go ahead with the stock you want to buy and choose to pay through the margin trading option. That’s all! Upstox will automatically add its share in the total amount and you just need to pay the remaining percentage of it. ',
  HOW_RETURN_MONEY: 'How do I return this money?',
  HOW_RETURN_MONEY_DESCRIPTION_1: 'You can do it in two ways:',
  HOW_RETURN_MONEY_DESCRIPTION_2:
    '1. Stocks bought with MTF appear under the Positions tab (not Holdings). So, you need to exit your ‘positions’ within 90 days (of your purchase).',
  HOW_RETURN_MONEY_DESCRIPTION_3:
    '2. You can also convert the MTF positions to Demat holdings (Delivery) by sending us an email. Do it within 90 days of your purchase. Make sure to have enough funds in your Upstox wallet to repay the borrowed amount. An additional Rs. 12+GST will be charged as your shares need to get unpledged from CDSL.',
  HOW_RETURN_MONEY_DESCRIPTION_4:
    'Note: Only those stocks, which we receive as per the T+2 (trade day + 2 days) cycle can be converted to Demat holdings (Delivery). ',
  HOW_RETURN_MONEY_DESCRIPTION_5:
    'Still, have questions? Refer to our FAQs for more details.',
  HOW_RETURN_MONEY_DESCRIPTION_5_LEFT: 'Still, have questions? Refer to our ',
  FAQ: 'FAQs ',
  HOW_RETURN_MONEY_DESCRIPTION_5_RIGHT: ' for more details.',
  HOW_RETURN_MONEY_DESCRIPTION_6:
    'Ready to activate Margin Trading Facility? Tap on the Activate button to proceed.',
  ACCEPT_TERMS_AND_CONDITIONS: 'I accept the terms and conditions',
  RIGHTS_AND_OBLIGATIONS_OF_STOCK:
    'RIGHTS & OBLIGATIONS OF STOCK BROKERS & CLIENTS FOR MARGIN TRADING FACILITY (MTF) - NSE',
  CLIENT_RIGHTS: 'CLIENT RIGHTS',
  CLIENT_RIGHTS_DESCRIPTIONS_1:
    '1. Client shall receive all communications in a mode mutually agreed between the broker and the client regarding confirmation of orders/trades, margin calls, decision to liquidate the position/security.',
  CLIENT_RIGHTS_DESCRIPTIONS_2:
    '2. Client shall be free to take the delivery of the securities at any time by repaying the amounts that was paid by the Stock Broker to the Exchange towards securities after paying all dues.',
  CLIENT_RIGHTS_DESCRIPTIONS_3:
    '3. Client has a right to change the securities collateral offered for Margin Trading Facility at any time so long as the securities so offered are approved for margin trading facility.',
  CLIENT_RIGHTS_DESCRIPTIONS_4:
    '4. Client may close/terminate the Margin Trading Account at any time after paying the dues.',
  CLIENT_OBLIGATIONS: 'CLIENT OBLIGATIONS',
  CLIENT_OBLIGATIONS_DESCRIPTIONS_1:
    '1. Client shall, in writing in his own hand or in any irrefutable electronic method, agree to avail of Margin Trading Facility in accordance with the terms and conditions of Margin Trading Facility offered by the broker, method of communication for confirmation of orders/trades, margin calls and calls for liquidation of collateral/security/position.',
  CLIENT_OBLIGATIONS_DESCRIPTIONS_2:
    '2. Client shall inform the broker of its intent to shift the identified transaction under MarginTrading Facility within the time lines specified by the broker failing which the transaction will be treated under the normal trading facility.',
  CLIENT_OBLIGATIONS_DESCRIPTIONS_3:
    '3. Client shall place the margin amounts as the Stock Broker may specify to the client from time to time.',
  CLIENT_OBLIGATIONS_DESCRIPTIONS_4:
    '4. On receipt of ‘margin call’, the client shall make good such deficiency in the amount of margin placed with the Stock Broker within such time as the Stock Broker may specify.',
  CLIENT_OBLIGATIONS_DESCRIPTIONS_5:
    '5. By agreeing to avail Margin Trading Facility with the broker, client is deemed to have authorized the broker to retain and/or pledge the securities provided as collateral or purchased under the Margin Trading Facility till the amount due in respect of the said transaction including the dues to the broker is paid in full by the client.',
  CLIENT_OBLIGATIONS_DESCRIPTIONS_6:
    '6. Client shall lodge protest or disagreement with any transaction done under the margin trading facility within the timelines as may be agreed between the client and broker.',
  STOCK_BROKER_RIGHTS: 'STOCK BROKER RIGHTS',
  STOCK_BROKER_RIGHTS_DESCRIPTION_1:
    '1. Stock Broker and client may agree between them selves the terms and condition including commercial terms if any before commencement of MTF.',
  STOCK_BROKER_RIGHTS_DESCRIPTION_2:
    '2. Stock broker may set up its own risk management policy that will be applicable to the transactions done under the Margin Trading Facility. Stock broker may make amendments there to at any time but give effect to such policy after the amendments are duly communicated to the clients registered under the Margin Trading Facility.',
  STOCK_BROKER_RIGHTS_DESCRIPTION_3:
    '3. The broker has a right to retain and/or pledge the securities provided as collateral or the securities bought by the client under the Margin Trading Facility.',
  STOCK_BROKER_RIGHTS_DESCRIPTION_4:
    '4. The broker may liquidate the securities if the client fails to meet the margin call made by the broker as mutually agreed of liquidation terms but not exceeding 5 working days from the day of margin call.',
  STOCK_BROKER_OBLIGATIONS: 'STOCK BROKER OBLIGATIONS',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_1:
    '1. Stock broker shall agree with the client the terms and condition before extending Margin Trading Facility to such client. However, for clients who already have existing trading relationship and want to avail of Margin Trading Facility, stock broker may take consent in writing in his own hand or in any irrefutable electronic method after stock broker has communicated the terms and conditions of Margin Trading Facility to such existing clients.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_2:
    '2. The terms and conditions of Margin Trading Facility shall be identified separately, in a distinct section if given as a part of account opening agreement.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_3:
    '3. The mode of communication of order confirmation, margin calls or liquidation of position/security shall be as agreed between the broker and the client and shall be inwriting in his own hand or in any irrefutable electronic method. Stock broker shall prescribe and communicate its margin policies on haircuts/ VAR margins subject to minimum requirements specified by SEBI and exchanges from time to time.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_4:
    '4. The Stock Broker shall monitor and review on a continuous basis the client’s positions with regard to MTF. It is desirable that appropriate alert mechanism is set up through which clients are alerted on possible breach of margin requirements.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_5:
    '5. Any transaction to be considered for exposure to MTF shall be determined as per the policy of the broker provided that such determination shall happen not later than T + 1 day.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_6:
    '6. If the transaction is entered under margin trading account, there will not be any further confirmation that it is margin trading transaction other than contract note.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_7:
    '7. In case the determination happens after the issuance of contract, the broker shall issue appropriate records to communicate to Client the change in status of transaction from Normal to Margin trading and should include information like the original contract number and the margin statement and the changed data.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_8:
    '8. The Stock Broker shall make a ‘margin call’ requiring the client to place such margin; any such call shall clearly indicate the additional/deficient margin to be made good.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_9:
    '9. Time period for liquidation of position/security shall be in accordance declared policy of the broker as applicable to all MTF clients consistently. However, the same should not be later than 5 working (trading) days from the day of ‘margin call’. If securities are liquidated, the contract note issued for such margin call related transactions shall carry an asterisk or identifier that the transaction has arisen out of margin call.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_10:
    '10. The daily margin statements sent by broker to the client shall identify the margin/collateral for Margin Trading separately.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_11:
    '11. Margin Trading Accounts where there was no transactions for 90 days shall be settled immediately.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_12:
    '12. The stocks deposited as collateral with the stock broker for availing margin tradingfacility (Collaterals) and the stocks purchased under the margin trading facility (Funded stocks) shall be identifiable separately and there shall not be any comingling for the purpose of computing funding amount.',
  STOCK_BROKER_OBLIGATIONS_DESCRIPTION_13:
    '13. Stock Broker shall close/terminate the account of the client forthwith upon receipt of such request from the client subject to the condition that the client has paid dues under MarginTrading Facility.',
  TERMINATION_OF_RELATIONSHIP: 'TERMINATION OF RELATIONSHIP',
  TERMINATION_OF_RELATIONSHIP_DESCRIPTION_1:
    '1. The margin trading arrangement between the stock broker and the client shall be terminated; if the Stock Exchange, for any reason, withdraws the margin trading facility provided to the Stock Broker or the Stock Broker surrenders the facility or the Stock Broker ceases to be a member of the stock exchange.',
  TERMINATION_OF_RELATIONSHIP_DESCRIPTION_2:
    '2. The MTF facility may be withdrawn by the broker, in the event of client committing any breach of any terms or conditions therein or at anytime after due intimation to client allowing such time to liquidate the MTF position as per the agreed liquidation terms without assigning any reason. Similarly, client may opt to terminate the margin trading facility in the event of broker committing any breach of any terms or conditions therein orfor any other reason.',
  TERMINATION_OF_RELATIONSHIP_DESCRIPTION_3:
    '3. In the event of termination of this arrangement, the client shall forthwith settle the dues ofthe Stock Broker. The Stock Broker shall be entitled to immediately adjust the Margin Amount against the dues of the client, and the client hereby authorizes the Stock Broker to make such adjustment.',
  TERMINATION_OF_RELATIONSHIP_DESCRIPTION_4:
    '4. After such adjustment, if any further amount is due from the client to the Stock Broker, the client shall settle the same forthwith. Upon full settlement of all the dues of the clientto the Stock Broker, the Stock Broker shall release the balance amount to the client.',
  TERMINATION_OF_RELATIONSHIP_DESCRIPTION_5:
    '5. If the client opts to terminate the margin trading facility, broker shall forthwith return to the client all the collaterals provided and funded securities retained on payment of all the dues by clients.',
  RIGHTS_AND_OBLIGATIONS_RELATING:
    'RIGHTS AND OBLIGATIONS RELATING TO MARGIN TRADING FACILITY PROVIDED BY STOCK BROKER/ TRADING MEMBERTO CLIENTS - BSE',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_1:
    '1. Stock Broker/ Trading Member is eligible to provide Margin Trading Facility (MTF) in accordance with SEBI& Exchange Guidelines as specified from time to time.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_2:
    '2. Stock Broker/ Trading Member desirous of extending MTF to their clients is required to obtain prior permission of BSE. Stock Broker/Trading Member may note that BSE hasthe right to withdraw the permission at anytime.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_3:
    '3. Stock Broker/Trading Member shall extend the MTF to the client, on such terms and conditions as specified by the Stock Exchange/SEBI from time to time. Stock Broker/Trading Member and the client shall abide by the requirements of the margin trading framework, including rights and obligations, as prescribed by Stock Exchange/SEBI/Stock Broker/ Trading Member.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_4:
    '4. Stock Broker/Trading Member shall intimate all the terms and conditions, including maximum allowable exposure, specific stock exposures etc., as well as the rights and obligations to the client desirous of availing MTF.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_5:
    '5. Stock Broker/Trading Member may, at its sole and absolute discretion, increase the limitof initial and/or maintenance margin, from time to time. The Client shall abide by such revision, and where there is an upward revision of such margin amount, he agrees to makeup the shortfall within such time as the Stock Broker/Trading Member may permit. Itmay however, be noted that the initial/maintenance margins shall never be lower than that prescribed by Stock Exchange/ SEBI.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_6:
    '6. Stock Broker/Trading Member shall provide MTF only in respect of such shares, as maybe permitted by Stock Exchange/SEBI.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_7:
    '7. Stock Broker/Trading Member shall liquidate the securities and other collateral, if theclient fails to meet the margin call to comply with the margin requirement as specified byStock Exchange/SEBI/Stock Broker/Trading Member. In this regard, Stock Broker/Trading Member shall also list down situations/ conditions in the which the securitiesmay be liquidated (Stock Broker/Trading Member to list down situations/conditions)',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_8:
    '8. Stock Broker/Trading Member shall not use the funds of one client to provide MTF toanother client, even if the same is authorized by the first client.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_9:
    '9. The stocks deposited as collateral with the Stock Broker/Trading Member for availing margin trading facility (Collaterals) and the stocks purchased under the margin trading facility (Funded stocks) shall be identifiable separately and no comingling shall bepermitted for the purpose of computing funding amount.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_10:
    '10. IPF shall not be available for transactions done on the Stock Exchange, through MTF, in case of any losses suffered in connection with the MTF availed by the client.',
  RIGHTS_AND_OBLIGATIONS_RELATING_DESCRIPTION_11:
    'The rights and obligations prescribed here in above shall be read in conjunction with the rights and obligations as prescribed under SEBI circular no. CIR/MIRSD/16/2011dated August 22, 2011.',
  TERMS_AND_CONDITIONS_OF_RKSV:
    'TERMS AND CONDITIONS OF RKSV SECURITIES INDIA PVT. LTD. (UPSTOX) FORMARGIN TRADING FACILITY',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_1:
    'The Margin Trading Facility would be available in accordance to the additional terms and condition laid down below:',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_2:
    '1. To avail the Margin Trading Facility by client the minimum margin requirement wouldbe 50% of Purchase value or upto VAR + 5 times of ELM whichever is higher.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_3:
    '2. Such margin would be only in the form of CASH. No Margin Trading Facility would beextended against collateral.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_4:
    '3. The Client understands that Margin Trading Facility would be extended only for theStocks as determined by Upstox from time to time.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_5:
    '4. No client would be funded beyond Rs. 5,00,000.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_6:
    '5. Post square off (whether by client or Upstox), margins would be released from T+1 day.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_7:
    '6. The tender period for Margin Trading position so taken up by the client would be valid up to 90 calendar days from the trade date of such position. Clients would be required to release such a position on or before the 90th day by taking delivery of such shares by paying the funded amount to Upstox or by squaring off such position. Any pending position beyond the 90th day may be squared off at the prevailing market rates on best effort basis by Upstox; Upstox shall not be responsible for any loss arising to client from such square off, further clients would not be allowed to take any new position in the same script for position squared off by Upstox. Post squaring off of the position funds would first be allocated towards satisfying the funded, interest accumulated to Upstox and statutory charges as applicable and only the balance would be credited to the clientledger.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_8:
    '7. Fees, Charges, Interest & Penalty:',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_9:
    'a. Brokerage of Rs. 20 or 2.5% whichever is less would be applicable per order (onboth Buy and Sell Transaction, whether delivery or Intraday or BTST trade) underMargin Trading Facility.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_10:
    'b. Pledge/Unpledge/confiscation (Invocation) charges @ Rs. 20 shall beapplicable.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_11:
    'c. Square off charges @ Rs. 50 shall be levied for every position so squared off byUpstox.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_12:
    'd. Interest charges* for using Margin Trading Facility would be Rs. 20 per day forevery 50000 of the funded amount.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_13:
    'e. Penalty @ Rs. 50 per day for every 50000 of the funded amount as provided forcondition in clause 9.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_14:
    '* The charges would be applicable from the date of funds PayIn to the exchange sand till the date of funds payout received from the exchange post square off of the Margin Trading position.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_15:
    'f. Other statutory charges and taxes shall apply as applicable.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_16:
    '8. As per regulatory requirement for entering into Margin Trading position, clients would be prompted to create a future pledge at the CDSL systems in favour of RKSV Securities India Pvt. Ltd – MTF Account. Clients would be required to confirm such pledge by 9:30 p.m. on the trade day to continue the MTF position.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_17:
    '9. Non acceptance of pledge request as per the timelines given in clause 8, would lead to converting the MTF position to normal position on T+1 day. Such a position shall besquared off any time after the settlement day but before the regulatory norms. Funds blocked during the settlement of such position(s) would be liable to penalty as provided inclause 7.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_18:
    '10. The Margin Trading position of the client shall always be marked to market. Accordingly, at any point of time, if the MTM loss of the client goes beyond 40% of the position valueof any particular script, the client position for such script would be squared off at the prevailing market rate by confiscating (invoking) the shares associated to such position ofthe client. Statutory charges applicable for confiscating the shares would be borne by the client.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_19:
    '11. Client shall be solely responsible to fulfill any margin calls made by Upstox during the existence of the position. Non fulfilling of margin requirements would mandate Upstox to confiscate the shares and sell them at the prevailing market rate.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_20:
    '12. In case there is a shortfall in receipt of securities against the buy position of the client, such shortfall shall be dealt with in the following manner:',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_21:
    'a. In case there is a payout shortage(s) on the settlement day from the exchange for bought MTF position(s), the same would be converted to normal delivery in theclient’s account. The shares thus received on the settlement date or under Auction payout would be delivered to the clients demat account upon full payment of the position else would be held back in CUSA account. The client will have to make the payment on or before T+3 day. The shares will be squared off by Upstox on T+4 day on failure of the payment as above.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_22:
    ' b. In case of the close out credit from the exchange for the bought MTF position(s), the same would be credited to the client’s account.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_23:
    'Under both the above points (a & b) Upstox shall first recover the funded amount andonly the balance amount (if any) would be credited to the clients ledger on thesettlement date. Upstox shall not be liable for any loss arising to the client.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_24:
    '13. To satisfy any obligation/dues of the client under Margin Trading Facility fundsfrom the client’s normal ledger would be moved to his/her MTF ledger by passing a JV.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_25:
    '14. Client shall at all times be fully responsible to make good any dues pending to bepaid to Upstox, such dues may not be limited to only funded amount or charges, it mayalso include statutory charges, Taxes etc.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_26:
    '15. On squaring off any position by client or by Upstox from such sale value the funded amount, applicable taxes, applicable charges and applicable upfront margin would first be reduced and only on the balance amount further exposure shall be granted.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_27:
    '16. If at any point there is any margin shortfall, the client shall be responsible for penalties applicable (if any).',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_28:
    "17. The client understands that Upstox shall be reporting to the stock exchanges on adaily basis the details of the client's funded position/collaterals position and such other details as may be required.",
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_29:
    '18. The client understands that Upstox reserves the right to modify any of the termsin the relation to Margin Trading facility so provided here in the document.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_30:
    '19. The client understands that from the date of signing this document if there are any regulatory/operational changes in the functioning of the Margin Trading Facility, such changes shall apply without any intimation to the client.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_31:
    '20. Upstox reserves the right to deny providing of the Margin Trading Facility to anyclient without assigning any reason. During the existence of the agreement, if it is foundany breach/fraud has been committed by the client against Upstox, such client shall beliable to make good all the financial loss incurred by Upstox including any legal andtechnical cost that would have been borne by Upstox. The client would also be subject toany legal action as may be necessary.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_32:
    '21. Upstox also reserved the right to withdraw the Margin Trading facility any time by issuing a notice of not greater than 30 days to its clients. On withdrawal of such a facility, a client would be required to settle its position and clear out any pending dues.',
  TERMS_AND_CONDITIONS_OF_RKSV_DESCRIPTION_33:
    '22. The client understands that the service provided here under is through the use of software’s and systems. If at any point of time there is any technical failure, Upstox or the exchange shall not be responsible for any loss suffered by the client.',
  OTP_SEND_ON: (number: string) =>
    `Enter the 6-digit OTP received on ${number}`,
  MTF_ACTIVATION_FAILED: 'Activation failed',
  MTF_ACTIVATION_FAILED_DESCRIPTION:
    'We couldn’t activate Margin Trading Facility (MTF) on your account due to <mention failure reason>.',
  MTF_ACTIVATION_SUCCESS: 'MTF activated!',
  MTF_ACTIVATION_SUCCESS_DESCRIPTION:
    'We’ve activated Margin Trading Facility (MTF) on your account. You can now pay for Delivery trades with 50% of the funds.',
  RESET_OTP: 'Resend OTP',
  OTP_LENGTH_INVALID: 'It should be a 6-digit OTP.',
  MTF_TITLE: 'Get up to 50% funds from us',
  MTF_SUBTITLE: 'Borrow funds by our Margin Trading Facility',
  MTF_WARNING_TITLE_LEFT:
    'You are now using margin trading facility. Learn more about ',
  MTF_WARNING_TITLE_RIGHT: ' associated with margin trading facility',
  MTF_WARNING_LINK: 'the benefits and risks',
  MTF_SUCCESS: 'with 50% margin has been sent to the exchange.',
  MTF: 'MTF',
  MTF_POSITIONS_BANNER_TITLE: 'MTF authorizaton required',
  MTF_POSITION_BANNER_DESCRIPTION:
    'As per CDSL, we need your approval to provide funds under Margin Trading Facility for the trades placed on ',
  AUTHORIZE: 'Authorize',
  POSITION_SEARCH_EMPTY_STATE_DESCRIPTION: 'Try searching a different position',
  HOLDING_SEARCH_EMPTY_STATE_DESCRIPTION: 'Try searching a different holding',
  ORDER_SEARCH_EMPTY_STATE_DESCRIPTION: 'Try searching a different order',
  MTF_ORDER_BANNER_TITLE: 'Get up to 50% funds from us',
  MTF_ORDER_BANNER_DESCRIPTION:
    'Activate Margin Trading Facility to borrow up to 50% funds for this order',
  UNAUTHORIZED_REQUEST: 'Unauthorized Request',
  LOGIN_SESSION_EXPIRED_MESSAGE:
    'Your identity token has expired. Please login again.',
  FUNDAMENTALS: 'Fundamentals',
  KEY_INDICATORS: 'Key Indicators',
  FINANCIALS: 'Financials',
  FINANCIAL_RATIO: 'Financial Ratios',
  SHAREHOLDING_INFO: 'Shareholding Info',
  CORPORATE_ACTION: 'Corporate Action',
  SECTOR: 'Sector',
  MARKET_CAP: 'Market cap',
  DOUGHNUT_CHART_HINT: 'Click on the graph to see other sections',
  PRICE_EARNING_RATIO: 'P/E ratio',
  PRICE_BOOK_VALUE_RATIO: 'P/B ratio',
  RETURN_ON_EQUITY: 'ROE',
  RETURN_ON_CAPITAL_EMPLOYED: 'ROCE',
  DIVIDEND_YIELD: 'Dividend yield',
  DEBT_TO_EQUITY: 'Debt to equity',
  PROFITABILITY_RATIOS: 'Profitability Ratios',
  OPERATIONAL_RATIOS: 'Operational Ratios',
  VALUATION_RATIOS: 'Valuation Ratios',
  NET_INTEREST_MARGIN: 'NIM',
  RETURN_ON_ASSETS: 'ROA',
  CREDIT_DEPOSIT_RATIO: 'Credit Deposit Ratio',
  NET_PROFIT_MARGIN: 'Net profit margin',
  EARNINGS_PER_SHARE: 'EPS',
  OP_PROFIT_MARGIN: 'Op profit margin',
  ROIC: 'ROIC',
  GROSS_NPA: 'Gross NPA',
  NET_NPA: 'NET NPA',
  CASA: 'CASA',
  CAPITAL_ADEQUACY_RATIO: 'CAR',
  QUICK_RATIO: 'Quick Ratio',
  CURRENT_RATIO: 'Current Ratio',
  INTEREST_COVERAGE_RATIO: 'Interest Coverage',
  ASSET_TURNOVER: 'Asset Turnover',
  PRICE_TO_BOOK: 'P/B',
  EVEBITDA: 'EV/EBITDA',
  WHAT_IS: (type: string) => `What is ${type} ?`,
  INCOME_STATEMENT: 'Income Statement',
  CASH_FLOW: 'Cash Flow',
  REVENUE: 'Revenue',
  OPERATING_PROFIT: 'Operating Profit',
  NET_PROFIT: 'Net profit',
  CONSOLIDATED: 'Consolidated',
  QUARTERLY: 'Quarterly',
  STANDALONE: 'Standalone',
  YEARLY: 'Yearly',
  CHOOSE_REPORT_TYPE: 'Choose a report type',
  CHOSE_REPORT_DURATION: 'Choose a report duration',
  SCHEDULE_UNIT: (unitsIn: string) => `All values are in ${unitsIn}`,
  INCOME_STATEMENT_MODAL_HEADING: 'What is Income Statement?',
  OPERATING: 'Operating',
  INVESTING: 'Investing',
  FINANCING: 'Financing',
  BALANCE_SHEET: 'Balance Sheet',
  TOTAL_ASSETS: 'Total assets',
  TOTAL_LIABILITIES: 'Total liabilities',
  FINANCIAL_BALANCE_SHEET: 'Balance sheet',
  NO_CORPORATE_ACTIONS: 'No corporate actions',
  NO_INCOME_STATEMENT: 'No income statement data',
  NO_CASH_FLOW: 'No cash flow data',
  NO_BALANCE_SHEET: 'No balance sheet data',
  NO_SHAREHOLDING_INFO: 'No shareholding info',
  NO_KEY_INDICATORS: 'No Key Indicators data',
  NO_OPERATIONAL_RATIOS: 'No Operational Ratios data',
  NO_PROFITABILITY_RATIOS: 'No Profitability Ratios data',
  NO_VALUATION_RATIOS: 'No Valuation Ratios data',
  EX_DATE: (name: string) => `Ex ${name} Date`,
  ANNOUNCEMENT_DATE: 'Announcement Date',
  RECORD_DATE: 'Record Date',
  DIVIDENT_TYPE: 'Divident Type',
  DIVIDEND: 'Dividend',
  DIVIDEND_PERCENTAGE: 'Divident %',
  DETAILS: 'Details',
  RATIO: 'Ratio',
  OLD_FACE_VALUE: 'Old Face Value',
  NEW_FACE_VALUE: 'New Face Value',
  VIEW_ALL_CORPORATE_ACTIONS: 'View all corporate actions',
  NA: 'NA',
  PREMIUM: 'Premium',
  BONUS: 'Bonus',
  SPLIT: 'Split',
  RIGHTS_ISSUE: 'Rights Issue',
  'RIGHTS ISSUES': 'Rights',
  DISCLAIMER_TITLE: 'Disclaimer:',
  DISCLAIMER_SUBTITLE: 'Financial data feed provided by Accord Fintech.',
  DISCLAIMER_TEXT:
    "Stock investing requires careful analysis of financial data to find out the company's true worth. The information shown here only informs about critical factors that you must look at before investing. Make sure you do your thorough stock analysis to make informed and calculated risk decisions.",
  NEW_TO_IPO: 'New to IPO?',
  LEARN_MORE_ABOUT_IPO: 'Learn more about applying to IPO',
  IPO_TABLE_NAME: 'Name',
  IPO_TABLE_BIDDING_DATES: 'Bidding dates',
  IPO_TABLE_PRICE_RANGE: 'Price range',
  IPO_TABLE_LOT_SIZE: 'Lot size',
  IPO_TABLE_STAGE: 'Stage',
  SHARES: 'shares',
  ACCEPT_UPI_MANDATE: 'Accept UPI mandate',
  AWAITING_ALLOTMENT: 'Awaiting allotment',
  APPLICATION_FAILED: 'Application failed',
  NOT_ALLOTED: 'Not alloted',
  YOU_HAVE_PRE_APPLIED: 'You have Pre-applied',
  YOU_GOT_THE_IPO: 'You got the ipo',
  APPLY: 'Apply',
  PRE_APPLY: 'Pre apply',
  IPO_CLOSED: 'IPO closed',
  ADVANCED_SETTINGS: 'Advanced settings',
  STOP_LOSS_SELL: (side: string) => `Stop loss (${side})`,
  TARGET_SELL: (side: string) => `Target (${side})`,
  VALIDITY_TRIGGERED: 'Validity (when triggered)',
  ALERTS_PERMISSIONS_TERMS: `Get an alert when your order is about to
  meet the conditions you've set.`,
  ORDER_VALID: (date: string) => `Order active till: ${date}`,
  CONDITIONAL_BANNER_TEXT:
    "Set a price condition for your order, and we'll place it only when it meets the specified criteria.",
  CONDITIONAL_SHARES: (count: string, side: string) =>
    `Conditional ${side} ${count} share(s)`,
  VALIDITY_DESCRIPTION:
    'Your order has validity until the end of the trading day.',
  PLACE_ORDER_IF: 'Place order if price is',
  CONDITIONAL_ORDER_MODAL_TITLE:
    "You're about to schedule your conditional order",
  CONDITIONAL_ORDER_MODAL_TEXT_1:
    "Your order is sent to the exchange only when the conditions you've set are met.",
  CONDITIONAL_ORDER_MODAL_TEXT_2:
    'This order request is active for 365 days from the day you create it.',
  CONDITIONAL_ORDER_MODAL_TEXT_3:
    'Please maintain sufficient balance to complete the order when it’s triggered.',
  CONDITIONAL_ORDER_MODAL_TEXT_4:
    'You may have to authorise your order with a TPIN when your order is executed.',
  DONT_SHOW_AGAIN: 'Don’t show again',
  DONT_SHOW_MESSAGE_AGAIN: 'Don’t show this message again.',
  SCHEDULED_YOUR_ORDER: 'We’ve scheduled your order to ',
  IF_ORDER_PRICE: (price: string, direction: string) =>
    `• if the Price is ${direction} ${price}`,
  TRACK_AND_EDIT_ORDER_TEXT_1: 'You can track or edit this order in ',
  TRACK_AND_EDIT_ORDER_TEXT_2:
    ' orders. Make sure you keep sufficient balance in your Upstox account for this order.',
  CONDITIONAL_ORDER: 'Conditional Order',
  CONDITIONAL_SUMMARY_PRICE: (direction: string) => `Price ${direction}`,
  STOPLOSS: 'Stoploss',
  TARGET: 'Target',
  CONDITIONAL_ORDER_SUBMISSION: 'Order Submission',
  CONDITIONAL_ORDER_EXPIRY: 'Order Expiry',
  DAYS: 'days',
  REGULAR: 'Regular',
  CONDITIONAL: 'Conditional',
  CONDITIONAL_ORDER_STOPLOSS_VALUE: (stopLossPercent: string) =>
    `Stoploss @ ${stopLossPercent}`,
  CONDITIONAL_ORDER_TARGET_VALUE: (squareOffPercent: string) =>
    `Target @ ${squareOffPercent}`,
  BELOW: 'below',
  ABOVE: 'above',
  ENTRY_PRICE: 'Entry price',
  VALIDITY_WHEN_TRIGGERED: 'Validity (when triggered)',
  AUTHORIZATION_REQUIRED: 'Authorization required',
  AUTHORIZE_ORDER: 'Authorise order',
  DISMISS: 'Dismiss',
  AUTHORISATION_COMPLETE: 'Authorization is complete',
  EDIS_CONDITIONAL_SUCCESS_DESCRIPTION:
    'Your transaction has been successfully verified. You may go to orders to view the status of the transaction.',
  MODIFY_CONDITIONAL_ORDER_BANNER_TEXT:
    'Certain fields are not able to be modified based on the order type.',
  MODIFY_SUCCESS_MESSAGE_FIRST_PART: 'Your order to Conditional',
  MODIFY_SUCCESS_BANNER_TEXT:
    'Please ensure that you maintain sufficient balance to complete the order.',
  I_ACCEPT_ALL: 'I accept all',
  CONDITIONAL_SUCCESS_MESSAGE:
    'Your order was successfully completed at the Price condition defined by you!',
  CONDITIONAL_CHILD_AWAITING_MESSAGE:
    'Your 1st order was successfully completed at the Price condition defined by you! We are still awaiting for rest of the conditions to meet.',
  CONDITIOPNAL_CHILD_CANCELED_MESSAGE:
    'Your 1st order was successfully completed at the Price condition defined by you! Rest of the orders were cancelled.',
  PRICE_CONDITIONS: 'Price conditions',
  ADDING_PRICE_CONDITIONS: 'Adding a price condition',
  PRICE_CONDITIONS_MODAL_TEXT_1:
    'You can decide when you want the order to be sent to the exchange, by adding a price condition to your order:',
  BELOW_CAPITALIZE: 'Below',
  ABOVE_CAPITALIZE: 'Above',
  PRICE_CONDITIONS_MODAL_TEXT_2: (
    titleDirection: string,
    priceDirection: string,
    minPercent: string,
    maxPercent: string,
  ) =>
    `${titleDirection} - If you select “${priceDirection}”, your order will be placed when the price of the stock is below the Price (₹) or Price (%) you provide. You can enter a value between ${minPercent}% to ${maxPercent}% of the current price.`,
  WHAT_ARE_ADVANCE_SETTINGS: 'What are Advance Settings?',
  ADVANCE_SETTINGS_MODAL_TEXT:
    'Enable Advance Settings to set stop-loss and target price both to place this order.',
  PERCENT_MORE_ERROR_MESSAGE: (percentage: string) =>
    `Percent must be more than or equal ${percentage}%`,
  PERCENT_LESS_ERROR_MESSAGE: (percentage: string) =>
    `Percent must be less than or equal ${percentage}%`,
  PRICE_MORE_ERROR_MESSAGE: (price: string) =>
    `Price must be more than or equal ${price}`,
  PRICE_LESS_ERROR_MESSAGE: (price: string) =>
    `Price must be less than or equal ${price}`,
  CONDITIONAL_TRADED_QTY: (qty: number | string, price: number | string) =>
    `${qty} contract(s) x ${price}`,
  PERCENTAGE_LIMIT_ERROR: (lowValue: string, maxValue: string) =>
    `Please enter value between ${lowValue}% and ${maxValue}%`,
  NO_OPEN_IPO:
    "No open IPOs right now. We'll update this space as soon as an IPO is announced.",
  CREATE_WATCHLIST_ERROR_MESSAGE: 'Failed to create a list. Please try again.',
  IPO_LIST_ERROR_MESSAGE: 'We couldn’t load open IPOs.',
  PAST_WEEK: 'Past week',
  PAST_MONTH: 'Past month',
  PAST_YEAR: 'Past year',
  PAST_3_YEARS: 'Past 3 years',
  PAST_5_YEARS: 'Past 5 years',
  BUY_STOP_LOSS_LIMIT_ORDER_ERROR_MESSAGE_1:
    'For Buy Order, Limit order price should be greater than Stop price',
  BUY_STOP_LOSS_LIMIT_ORDER_ERROR_MESSAGE_2:
    'For Buy Order, Stop order price should be greater than Last traded price',
  SELL_STOP_LOSS_LIMIT_ORDER_ERROR_MESSAGE_1:
    'For Sell Order, Limit order price should be less than Stop price',
  SELL_STOP_LOSS_LIMIT_ORDER_ERROR_MESSAGE_2:
    'For Sell Order, Stop order price should be less than Last Traded price',
  CIRCUIT_LIMIT_ERROR: (lowerCircuit: string, upperCircuit: string) =>
    `The price set should be within the circuit limits ${lowerCircuit} to ${upperCircuit}. Please modify your order price.`,
  WATCHLIST_ADD_SCRIP_TITLE: 'Add scrip to watchlist',
  ORDER_PANEL_MUTILPLE_OF_QUANTITY_ERROR_MESSAGE:
    'Specified value is not a multiple of the instrument quantity step of {step}.',
  WATCHLIST_SYMBOL_IS_ALREADY_IN_WATCHLIST_MESSAGE:
    'Symbol is already part of the Watchlist',
  QUANTITY_INPUT_ERROR_MESSAGE: 'Only numbers allowed',
  NON_TRADABLE_REASON: (exchangeToken: string, displayName: string) =>
    `You can't trade the symbol ${exchangeToken}:${displayName}.`,
  DORMANT_USER_ERROR:
    'This segment is marked as dormant due to inactivity. Please enter the following link in your browser to place a reactivation request. \n https://account.upstox.com/segments',
  UNABLE_TO_PERFORM_ACTION_TRY_AGAIN:
    'Unable to perform action. Please try again.',
  STOCK_OPTIONS_NOT_ALLOWED:
    'Market orders are not allowed on stock options.Place a limit order instead.',
  CANNOT_CLOSE_MTF_POSITION: 'Cannot close MTF position from Trading View',
  CLOSE_POSITION_TITLE: 'Close position at market price ?',
  POSITION_TITLE: 'Position',
  DUPLICATE_NAME: 'Duplicate name',
  ORDER_REJECTED_ERROR_MESSAGE: 'Your order has been rejected.',
  OPTION_CHAIN_NOT_AVAILABLE: (futureScrip: string) =>
    `${futureScrip ? '' : 'Futures & '}Options unavailable for this symbol.`,
  DASHBOARD: 'Dashboard',
  EDIS_CONNECTION_ERROR: 'Connection error for edis verification status',
  API_AMO_ERROR_MESSAGE:
    "Markets are closed right now, you can't place this order. Place an After-Market-Order (AMO) instead. Select 'AMO' under 'Order Complexity' from the order entry screen.",
  AMO_ERROR_MESSAGE:
    "Markets are closed right now, you can't place this order.",
  CLOSE_POSITION_DISCLAIMER:
    'Charges on this trade would be reflected in the contract note.',
  CHARGES_CALCULATION_DISCLAIMER:
    'Charges calculated above are on approximate basis. Actual charges for the completed order may differ.',
  INTRADAY_BROKERAGE_DISCLAIMER:
    'Brokerage would be charged on actual value if the transaction is categorised as intraday.',
  DP_CHARGES_DISCLAIMER: (dpCharge: string) =>
    `DP charge of ₹${dpCharge} + GST per scrip once per day would apply for sell delivery trade.`,
  BROKERAGE_AND_CHARGES_ERROR_DISCLAIMER:
    'Charges not visible at the moment, proceed to place your order. Charges will reflect in your contract note.',
  BROKERAGE_CHARGES: 'Brokerage charges',
  ESTIMATION_CHARGES_FAILURE: 'Charges not visible at the moment, proceed to place your order. Charges will reflect in your contract note.',
  LAST_TRADING_DATE: 'Last trading date',
  CHARGES_AND_TAXES: 'Charges & taxes',
  CHARGES: 'Charges',
  TAXES: 'Taxes',
  ORDER_REVIEW_INSTRUCTION_TEXT:
    'Order details will be shown every time before placing an order, only if your instant orders placement is not selected.',
  WANT_TO_REVIEW: 'Yes, I want to review',
  DONT_WANT_TO_REVIEW: 'No, I don’t want to review',
  PLACE_ORDER_AT_MARKET_PRICE: 'Place order at market price?',
  INSTANT_ORDER_DISCLAIMER:
    'Since you have enabled the instant orders placement, you won’t be able to review the order details.',
  SURVEILLANCE_WARNING: 'Security is under surveillance',
  PRERISK_CONTINUE: 'Order anyway',
  FAILED_TO_LOAD: 'Failed to load',
  FAILED_TO_SAVE: 'Failed to save',
  FAILED_TO_DELETE: 'Failed to delete',
  FAILED_TO_RENAME: 'Failed to rename',
  FETCHING_CHART_SETTINGS_FAILED: 'Error in fetching chart settings',
  SAVING_CHART_SETTINGS_FAILED: 'Error in saving chart settings',
  DELETING_CHART_SETTINGS_FAILED: 'Error in deleting chart settings',
  SAVE_SETTINGS: 'Save settings',
  EXCEEDING_LIMIT_WARNING_MESSAGE_1: 'The following charts & templates exceed the size limit.',
  EXCEEDING_LIMIT_WARNING_MESSAGE_2: 'Please retry with a smaller size.',
  UPLOADING_TO_CLOUD: 'Uploading to cloud',
  UPLOADING_TO_CLOUD_IN_PROGRESS: 'It\'s almost done! Please don\'t close it or go back until all charts are uploaded.',
  UPLOADED_SUCCESSFULLY: 'Uploaded successfully',
  UPLOADING_TO_CLOUD_SUCCESS: 'You can now access your saved charts & templates from any device or browser.',
  UPLOAD_FAILED: 'Upload failed',
  UPLOAD_TO_CLOUD_FAILED: 'The following charts & templates weren’t uploaded:',
  SYNCING_SECOND_TIME_ERROR_MESSAGE: 'You have already synced the chart settings once, So local changes will not be synced this time.',
  SOME_CHART_DETAILS_EXCEED_LIMIT: 'There are some chart details which cannot be synced as those exceed the maximum limit provided to save chart details.',
  CHARTS_OR_TEMPLATES_EXCEED_SIZE_LIMIT: 'You have exceeded the maximum limit provided to save chart details',
  CHARTS_EXCEEDS_MAX_LIMIT: (limit: string) => `You have exceeded the maximum limit of ${limit} chart layouts`,
  TEMPLATES_EXCEEDS_MAX_LIMIT: (limit: string) => `You have exceeded the maximum limit of ${limit} study templates`,
  CHART_LOCAL_STORAGE_SWITCH_BACK_CONTENT: 'You\'ve some charts & templates saved on cloud storage. If you continue, these won\'t be moved to local storage.',
  CHART_CLOUD_STORAGE_SWITCH_BACK_CONTENT: (totalChartsAndTemplatesInLocal: string) => `You've ${Number(totalChartsAndTemplatesInLocal)} charts & templates saved on local storage. If you continue, these will get deleted automatically.`,
  CLOUD_STORAGE_KEY_POINT_1: 'Access saved charts & templates from any device or browser',
  CLOUD_STORAGE_KEY_POINT_2: 'A max. of 20 latest charts & 20 templates will be uploaded',
  CLOUD_STORAGE_KEY_POINT_3: 'You can change this setting anytime from the Profile section',
  LOCAL_STORAGE_DATA: 'Continue to access your saved charts & templates only on this browser and device',
  CLOUD_STORAGE: 'Cloud storage',
  LOCAL_STORAGE: 'Local storage',
  RECOMMENDED: 'Recommended',
  SEBI_ODR_PORTAL: 'SEBI ODR portal',
  ASBA_REGISTRATION_PENDING_ERROR_MESSAGE: 'Your order cannot be placed until registration for UPI allocation is in progress',
  ASBA_DEREGISTRATION_PENDING_ERROR_MESSAGE: 'Your order cannot be placed until deregistration for UPI allocation is in progress',
  AVERAGE_PRICE_DISCREPANCY_ACTION: 'Update here',
  AVERAGE_PRICE_DISCREPANCY_HOLDING: 'holding',
  AVERAGE_PRICE_DISCREPANCY_HOLDINGS: 'holdings',
  AVERAGE_PRICE_DISCREPANCY_MESSAGE: 'may have inaccurate avg. price(s).',
  PRICE_ALERTS_LIST_HEADER: 'Price Alert',
  CREATE_ALERT_BUTTON: 'Create Alert',
  PRICE_ALERTS_EMPTY_STATE_HEADING: 'Currently No Price Alerts Set',
  PRICE_ALERTS_EMPTY_STATE_SUB_HEADING: 'Waiting for right opportunity? Set price alerts on companies you track.',
  SET_PRICE_ALERTS_TITLE: 'Set Alert on',
  DELETE_ALERT_BUTTON_NO: 'No',
  DELETE_ALERT_BUTTON_YES: 'Yes',
  DELETE_ALERT_MODAL_TITLE: 'Delete Alert',
  CREATE_PRICE_ALERTS_NOTE: 'You can set alerts individually for price above, below or both together.',
  CREATE_BUTTON: 'Create',
  UPDATE_BUTTON: 'Update',
  ADD_NOTES: 'Add a Notes',
  WRITE_NOTE_HERE: 'Write note here',
  FIELD_MUST_BE_NOT_EMPTY: 'Field must be not empty',
  LESS_THAN_ZERO_ERROR: 'Price cannot be less than or equal to zero',
  PRICE_BELOW_LTP_ERROR: 'Specified price is below the actual price',
  PRICE_ABOVE_LTP_ERROR: 'Specified price is above the actual price',
  RETRY_MESSAGE: 'Retry or check back later',
  ACTIVE: 'Active',
  TRIGGERED: 'Triggered',
  SCRIP_NAME: 'Scrip Name',
  ALERT_PRICE: 'Alert Price',
  AND: 'and',
  DELETE_ALERT_BANNER: 'Are you sure want to delete',
  QUESTION_SIGN: '?',
  DRAG_TO_MODIFY_PRICE_ALERT: 'Drag to modify alert price',
  CANCEL_ALERT: 'Cancel alert',
  ALERT_ON_VALUE: (value: string) => `Alert on ${value}`,
  PRICE_ALERT_NOTIFICATION_TITLE: 'Alert triggered',
  PRICE_ALERT_GREATER_THAN_TEXT: 'was greater than or equal to',
  PRICE_ALERT_LESS_THAN_TEXT: 'was less than or equal to',
  OPEN_CHART: 'Open chart',
  DEFAULT_ERROR_HELP_TEXT: 'Please try again. If the issue persists, contact Customer Support at support@upstox.com.',
  EDIT_ALERT: 'Edit alert',
  ALERT_ON: 'Alert on',
  ALERT_ON_TEXT: (
    name: string,
  ) => `Alert created on ${name}`,
  ALERT_ON_UPDATE_TEXT: (
    name: string,
  ) => `Alert updated on ${name}`,
  ALERT_ON_TEXT_DELETE: (name: string) => `Alert deleted on ${name}`,
  STRING_LENGTH_VALIDATION: (length: string, maxLength: string) => `${length}/${maxLength}`,
  EXPIRY: 'Expiry: ',
  MAX_PAIN: 'MaxPain',
  ATM_IV: 'ATM IV',
  IV_CHANGE: 'IV Change%',
  PCR: 'PCR',
  MARKET_LOT: 'Market Lot',
  DAYS_FOR_EXPIRY: 'Days for Expiry',
  SPOT_PRICE: 'Spot: ',
  FUTURE_PRICE: 'Fut: ',
  CANCEL_ORDER_FAILED: 'Failed to cancel order',
  WHATS_NEW: "What's new",
  RELEASE_NOTES: 'Release Notes',
  UNDERLYING_CHARTS: 'View Underlying',
  UNDERLYING_CHARTS_DISABLED_MESSAGE: 'Available only for scrips with underlying symbol',
  CONVERT_POSITION: 'Convert Position',
  CONVERT_INTRADAY_POSITION: 'Convert Intraday to Delivery',
  CONVERT_DELIVERY_POSITION: 'Convert Delivery to Intraday',
  TOTAL_QUANTITY: 'Total quantity',
  QUANTITY_TO_CONVERT: 'Quantity to convert',
  POSITION_CONVERSION_FAILED_TITLE: 'Position conversion failed',
  POSITION_CONVERSION_SUCCESS_TITLE: 'Position converted',
  POSITION_CONVERSION_SUCCESS_MESSAGE: 'Position converted successfully',
  CANNOT_DELETE_UPSTOX_LAYOUT_TEXT:
    'Upstox Layout cannot be deleted',
  CANNOT_RENAME_UPSTOX_LAYOUT:
    'Upstox Layout cannot be renamed',
  CANNOT_RENAME_LAYOUT_WITH_NAME_UPSTOX_LAYOUT:
    'Cannot rename a layout with name Upstox Layout',
  CANNOT_CREATE_LAYOUT_WITH_UPSTOX_LAYOUT_NAME:
    'Cannot create a layout with name Upstox Layout',
  FAILED_TO_SAVE_DRAWING_SOURCES: 'Failed to save drawing',
  CHART_SIZE_LIMIT_EXCEEDED: 'Chart size limit exceeded. Please delete some drawings',
} as const;
